import React from 'react';
import Image from 'Shared/ImageFallback';
import Button from 'Shared/Button';
import Icon from 'Shared/Icon';
import ReactSwipe from 'react-swipe';
import * as styles from './base.scss';
import { translate } from 'Shared/translate';
export default class ProductMedia extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        if (!arrayEquals(newProps.imageUrls, this.props.imageUrls)) {
            this.slideTo(0);
        }
    }
    componentDidUpdate() {
        // Only if imageUrls has more than one image.
        if (!!this.props.imageUrls &&
            this.props.imageUrls.length > 1) {
            this.swiper.swipe.setup();
        }
    }
    slideTo(index) {
        this.setState({ currentIndex: index }, () => this.swiper.swipe.slide(index));
    }
    render() {
        const shouldBeLoaded = (index) => {
            const indexesToLoad = [this.state.currentIndex - 1, this.state.currentIndex, this.state.currentIndex + 1];
            return indexesToLoad.indexOf(index) !== -1;
        };
        const len = this.props.imageUrls ? this.props.imageUrls.length : 0;
        const hasNext = this.state.currentIndex < len - 1;
        const hasPrev = this.state.currentIndex > 0;
        return (React.createElement("div", { className: styles.base },
            React.createElement("div", { className: styles.primary },
                React.createElement("div", { id: "large-image" },
                    React.createElement(ReactSwipe, { swipeOptions: {
                            continuous: false,
                            callback: index => this.slideTo(index),
                        }, ref: swiper => (this.swiper = swiper), key: this.props.id }, this.props.imageUrls &&
                        this.props.imageUrls.map((imageUrl, index) => (React.createElement("div", { key: imageUrl, className: styles.media },
                            React.createElement(Image, { preferSmallerIfCached: true, minSizeIfCached: "tiny", skipSrcSet: true, alt: this.props.name, size: "medium", src: shouldBeLoaded(index) ? imageUrl : '', "aria-hidden": index !== this.state.currentIndex }))))),
                    len === 0 && React.createElement(Image, null))),
            hasPrev && (React.createElement(Button, { appearance: ['round', 'secondary'], onClick: () => this.slideTo(this.state.currentIndex - 1), className: styles.prev },
                React.createElement("span", null,
                    React.createElement(Icon, { name: "arrow-left" })))),
            hasNext && (React.createElement(Button, { appearance: ['round', 'secondary'], onClick: () => this.slideTo(this.state.currentIndex + 1), className: styles.next },
                React.createElement("span", null,
                    React.createElement(Icon, { name: "arrow-right" })))),
            len > 1 && (React.createElement("ul", { className: styles.swiperPagination }, this.props.imageUrls.map((slide, index) => (React.createElement("li", { key: index, role: "button", tabIndex: 0, "aria-label": translate('/ProductMedia/GoToImage', `${index + 1}`), className: this.state.currentIndex === index ? styles.active : '', onClick: () => this.slideTo(index) })))))));
    }
}
function arrayEquals(array1, array2) {
    if (!array1 && !array2) {
        return true;
    }
    if (!array1 || !array2 || array1.length !== array2.length) {
        return false;
    }
    return (array1
        .slice()
        .sort()
        .join('') ===
        array2
            .slice()
            .sort()
            .join(''));
}
